// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d56483ef","173":"e9e4569b","244":"7b998f82","522":"b41ffcd1","561":"634fecf5","565":"7907a8af","942":"086019ab"}[chunkId] + ".chunk.js";
};